import { useEffect } from 'react'
import { useFormikContext } from 'formik'

import { EMPTY_LIST } from '../../../constants/common'
import { useScrollToInlineNotifications } from '../../../hooks'
import { NotificationInlineList } from '../../Notification'

import { QA_NAME_FORM_NOTIFICATIONS } from './FormInlineNotifications.constants'

import * as styles from './FormInlineNotifications.module.css'

function FormInlineNotifications({
  className = styles.formInlineNotifications,
  formikContext,
  headerRef,
  initialNotifications = EMPTY_LIST,
  notifications,
  qaName = QA_NAME_FORM_NOTIFICATIONS,
}) {
  const useHandlerFormikContext = !formikContext ? useFormikContext : undefined

  const { submitCount } = useHandlerFormikContext?.() || formikContext

  const { blockedCount, ref, setScrollToNotifications } =
    useScrollToInlineNotifications({ initialNotifications, notifications })

  useEffect(() => {
    if (blockedCount > 0) {
      setScrollToNotifications(prev => prev + 1)
    }
  }, [blockedCount, submitCount])

  return notifications.length > 0 ? (
    <NotificationInlineList
      className={className}
      items={notifications}
      qaName={qaName}
      ref={headerRef || ref}
    />
  ) : null
}

export default FormInlineNotifications
